import React from "react";
import { CircleDot } from "lucide-react";

export const LIGHT_STYLE = {
  green: { dot: "bg-emerald-500", chip: "border-emerald-200 bg-emerald-50 text-emerald-800", label: "Zahlt zuverlässig" },
  yellow: { dot: "bg-amber-400", chip: "border-amber-200 bg-amber-50 text-amber-800", label: "Zahlt verzögert" },
  red: { dot: "bg-rose-500", chip: "border-rose-200 bg-rose-50 text-rose-800", label: "Risiko" },
  unknown: { dot: "bg-slate-300", chip: "border-slate-200 bg-slate-50 text-slate-500", label: "Keine Erfahrung" },
};

export const EU_COUNTRIES = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"];
const COUNTRY_NAMES = { deutschland: "DE", germany: "DE", österreich: "AT", austria: "AT", frankreich: "FR", france: "FR", italien: "IT", italy: "IT", niederlande: "NL", netherlands: "NL", belgien: "BE", luxemburg: "LU", spanien: "ES", polen: "PL" };
export const isEuCountry = (c) => {
  const v = String(c || "").trim();
  if (!v) return false;
  const code = /^[A-Za-z]{2}$/.test(v) ? v.toUpperCase() : COUNTRY_NAMES[v.toLowerCase()];
  return EU_COUNTRIES.includes(code);
};

export function CreditLight({ score, compact = false, testId }) {
  if (!score) return null;
  const s = LIGHT_STYLE[score.light] || LIGHT_STYLE.unknown;
  const title = [s.label, score.score != null ? `Score ${score.score}/100` : null, ...(score.reasons || [])].filter(Boolean).join("\n");
  if (compact) {
    return <span className={`inline-block h-2.5 w-2.5 rounded-full ${s.dot}`} title={title} data-testid={testId} data-light={score.light} />;
  }
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${s.chip}`} title={title} data-testid={testId} data-light={score.light}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      {s.label}{score.score != null && <span className="opacity-70">· {score.score}</span>}
    </span>
  );
}

export function CreditWarning({ score, customerName, testId = "credit-warning" }) {
  if (!score || !["yellow", "red"].includes(score.light)) return null;
  const s = LIGHT_STYLE[score.light];
  return (
    <div className={`rounded-md border px-3 py-2 text-xs ${s.chip}`} data-testid={testId} data-light={score.light}>
      <div className="flex items-center gap-1.5 font-medium"><CircleDot className="h-3.5 w-3.5" />{score.light === "red" ? "Achtung: Risikokunde" : "Hinweis: Kunde zahlt verzögert"}{customerName ? ` – ${customerName}` : ""} (Score {score.score}/100)</div>
      <ul className="mt-1 list-disc pl-5 space-y-0.5 opacity-90">{(score.reasons || []).map((r, i) => <li key={i}>{r}</li>)}</ul>
      {score.light === "red" && <p className="mt-1">Empfehlung: Vorauskasse oder kürzere Zahlungsfrist vereinbaren.</p>}
    </div>
  );
}
